<template>
  <v-card class="ma-3" :style="cardStyle" id="app-usage">
    <Chart
      @lineChartUpdated="updateLineCharts()"
      :type="data.appUsageData.type"
      :data="series"
      ref="chart"
      class="text-capitalize"
      :options="data.appUsageData.options"
      :secondaryTitle="data.appUsageData.secondaryTitle"
      :yAxis="data.appUsageData.yAxis"
      :labels="labels"
      :title="data.appUsageData.title"
      elevation="0"
      width="95%"
    />
    <v-pagination
      v-if="series[0] && series[0].data.length > 0"
      v-model="currentPage"
      :length="pages"
      @input="getNextSection()"
      :total-visible="5"
      color="primary"
    ></v-pagination>
  </v-card>
</template>

<script>
import Chart from '@/components/charts/Chart';
import ScreenDetailData from '@/mixins/ScreenDetailData';
import card from '@/mixins/card';
import { MobileView } from '@/mixins';

export default {
  mixins: [ScreenDetailData, card, MobileView],
  components: {
    Chart,
  },
  data: () => ({
    series: [],
    labels: [],
    currentPage: 1,
  }),
  methods: {
    updateLineCharts() {
      if (this.$refs.chart.$refs.subchart.$refs.lineChart) {
        this.$refs.chart.$refs.subchart.$refs.lineChart.hideSeries(
          'Average Duration (Min)',
        );
        this.$refs.chart.$refs.subchart.$refs.lineChart.hideSeries(
          'Total Duration (Min)',
        );
      }
    },
    getNextSection() {
      this.series = [];
      this.labels = [];
      const dataCopy = JSON.parse(JSON.stringify(this.data.appUsageData));
      this.series[0] = dataCopy.data[0];
      this.series[1] = dataCopy.data[1];
      this.series[2] = dataCopy.data[2];
      this.series[0].data = dataCopy.data[0].data.slice(
        (this.currentPage - 1) * 5,
        this.currentPage * 5,
      );
      this.series[1].data = dataCopy.data[1].data.slice(
        (this.currentPage - 1) * 5,
        this.currentPage * 5,
      );
      this.series[2].data = dataCopy.data[2].data.slice(
        (this.currentPage - 1) * 5,
        this.currentPage * 5,
      );
      this.labels = dataCopy.labels.slice(
        (this.currentPage - 1) * 5,
        this.currentPage * 5,
      );
    },
  },
  computed: {
    pages() {
      const count = this.data.appUsageData.data[0].data.length;
      if (count <= 5) {
        return 1;
      }
      return Math.ceil(count / 5);
    },
    cardStyle() {
      if (this.showMobileView) {
        return 'height:100%; width:calc(100% - 24px);';
      }
      return 'height:100%; width:calc(50% - 24px);';
    },
  },
  mounted() {
    this.getNextSection();
  },
  watch: {
    data: {
      handler() {
        this.getNextSection();
      },
      deep: true,
    },
  },
};
</script>
